import React from 'react';
import Disclaimer from '../components/Disclaimer';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Terms = () => {
  return (
    <div className="min-h-screen bg-black">
      <Disclaimer />
      <Header />
      <div className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white">
            Conditions générales d'utilisation
          </h1>

          <article className="glass-strong rounded-2xl p-8 md:p-12 border border-white/10 space-y-8 text-white/80 leading-relaxed">
            <section>
              <p className="mb-4">
                <strong className="text-white">Dernière mise à jour : 08 décembre 2025</strong>
              </p>
              <p className="mb-4">
                Bienvenue sur rougebets.com. Ces conditions générales d'utilisation régissent votre accès et votre utilisation de notre site web. En accédant ou 
                en utilisant notre site, vous acceptez d'être lié par ces conditions. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">1. Acceptation des conditions</h2>
              <p className="mb-4">
                En accédant à rougebets.com, vous acceptez sans réserve les présentes conditions générales d'utilisation. Si vous n'acceptez pas ces conditions, 
                vous devez immédiatement cesser d'utiliser le site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">2. Description du service</h2>
              <p className="mb-4">
                Rouge Bets est un site indépendant de comparaison et d'avis sur les opérateurs de paris sportifs agréés en France. Nous fournissons des informations, 
                des comparaisons, des avis, et des guides pour vous aider à faire des choix éclairés concernant les sites de paris.
              </p>
              <p className="mb-4">
                Nous ne sommes pas un opérateur de paris et n'acceptons pas de paris directement. Nous fournissons uniquement des informations et des liens vers des 
                opérateurs tiers agréés.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">3. Utilisation du site</h2>
              <p className="mb-4">Vous vous engagez à utiliser notre site uniquement à des fins légales et de manière conforme à ces conditions. Vous acceptez de ne pas :</p>
              <ul className="list-disc list-inside mb-4 space-y-2">
                <li>Utiliser le site de manière à violer toute loi ou réglementation applicable</li>
                <li>Reproduire, dupliquer, copier ou vendre tout ou partie du site sans autorisation</li>
                <li>Utiliser des robots, scripts ou autres moyens automatisés pour accéder au site</li>
                <li>Tenter d'accéder à des zones non autorisées du site</li>
                <li>Transmettre des virus ou tout code malveillant</li>
                <li>Collecter des informations sur d'autres utilisateurs sans autorisation</li>
                <li>Utiliser le site pour des activités frauduleuses ou trompeuses</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">4. Propriété intellectuelle</h2>
              <p className="mb-4">
                Tout le contenu du site, incluant mais sans s'y limiter, les textes, graphiques, logos, images, et logiciels, est la propriété de Rouge Bets ou de 
                ses concédants de licence et est protégé par les lois sur la propriété intellectuelle.
              </p>
              <p>
                Vous pouvez consulter et imprimer des pages du site pour votre usage personnel et non commercial, mais vous ne pouvez pas reproduire, distribuer, 
                modifier ou créer des œuvres dérivées sans notre autorisation écrite préalable.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">5. Liens d'affiliation</h2>
              <p className="mb-4">
                Certains liens sur notre site sont des liens d'affiliation, ce qui signifie que nous pouvons recevoir une commission si vous cliquez sur ces liens 
                ou vous inscrivez via ces liens. Cela n'affecte jamais nos opinions, avis ou évaluations. Nous restons objectifs dans nos analyses indépendamment de 
                ces relations.
              </p>
              <p>
                Lorsque vous cliquez sur un lien vers un opérateur de paris, vous quittez notre site et êtes soumis aux conditions générales et politiques de 
                confidentialité de cet opérateur. Nous ne sommes pas responsables des pratiques ou du contenu de ces sites tiers.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">6. Exactitude des informations</h2>
              <p className="mb-4">
                Nous nous efforçons de fournir des informations exactes et à jour, mais nous ne garantissons pas l'exactitude, l'exhaustivité ou l'actualité de toutes 
                les informations sur le site. Les informations sont fournies "en l'état" sans garantie d'aucune sorte.
              </p>
              <p>
                Les bonus, promotions, et offres peuvent changer sans préavis. Nous vous encourageons à vérifier directement auprès des opérateurs pour les informations 
                les plus récentes concernant leurs offres et conditions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">7. Limitation de responsabilité</h2>
              <p className="mb-4">
                Dans la mesure permise par la loi, Rouge Bets ne sera pas responsable des dommages directs, indirects, accessoires, spéciaux ou consécutifs résultant de 
                l'utilisation ou de l'impossibilité d'utiliser notre site.
              </p>
              <p className="mb-4">
                Nous ne sommes pas responsables des pertes financières résultant de vos paris sur des sites tiers. Les paris sportifs comportent des risques, et vous 
                devez parier de manière responsable et uniquement avec des fonds que vous pouvez vous permettre de perdre.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">8. Jeu responsable</h2>
              <p className="mb-4">
                Nous encourageons fortement le jeu responsable. Les paris sportifs doivent être un loisir, pas un moyen de gagner de l'argent ou de résoudre des problèmes 
                financiers. Si vous pensez avoir un problème de jeu, consultez notre page <a href="/responsible-gaming" data-discover="true" className="text-toxic-green hover:text-toxic-cyan underline">Jeu responsable</a> 
                et les ressources disponibles.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">9. Modifications du site</h2>
              <p className="mb-4">
                Nous nous réservons le droit de modifier, suspendre ou interrompre tout ou partie du site à tout moment, avec ou sans préavis. Nous ne serons pas responsables 
                envers vous ou tout tiers pour toute modification, suspension ou interruption du site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">10. Modifications des conditions</h2>
              <p className="mb-4">
                Nous nous réservons le droit de modifier ces conditions générales à tout moment. Toute modification sera publiée sur cette page avec une date de mise à jour 
                révisée. Votre utilisation continue du site après la publication des modifications constitue votre acceptation des conditions modifiées.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">11. Droit applicable et juridiction</h2>
              <p className="mb-4">
                Ces conditions générales sont régies par le droit français. Tout litige relatif à ces conditions sera soumis à la juridiction exclusive des tribunaux français.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">12. Contact</h2>
              <p className="mb-4">
                Pour toute question concernant ces conditions générales, contactez-nous :
              </p>
              <ul className="list-none space-y-2">
                <li><strong className="text-white">Email :</strong> <a href="mailto:info@rougebets.com" className="text-toxic-green hover:text-toxic-cyan underline">info@rougebets.com</a></li>
                <li><strong className="text-white">Téléphone :</strong> <a href="tel:+33742963066" className="text-toxic-green hover:text-toxic-cyan underline">+33 7 42 96 30 66</a></li>
                <li><strong className="text-white">Adresse :</strong> Paris, France</li>
              </ul>
            </section>
          </article>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Terms;

